/** Workspace module chrome + paywall copy — prototype 20-nav-module additionalFeatures. */

export const SAAS_MODULE_META = Object.freeze({
  team: {
    label: "Team",
    group: "Admin",
    blurb: "Invite teammates and manage roles — Admin accounts only.",
  },
  actors: {
    label: "Actors",
    group: "Library",
    blurb: "Manage actor profiles for personalized talking-head videos.",
  },
  crm: {
    label: "CRM & Shopify",
    group: "Library",
    blurb: "Product-led create flows on Premium. Enterprise CRM is Contact sales.",
  },
  analytics: {
    label: "Video Analytics",
    group: "Insights",
    blurb: "Views, watch time, CTA clicks, and LMS engagement drills.",
  },
  metering: {
    label: "Usage & metering",
    group: "Insights",
    blurb: "See credit burn and usage by path (Avatar, voice, WhatsApp…).",
  },
  lms: {
    label: "LMS engagement",
    group: "Insights",
    blurb: "Views, watch time, CTA clicks, and LMS engagement drills.",
  },
});
